export default __webpack_public_path__ + "media/images/users/user-patrick-pool-270x270-a707790b4844b698ba8ca8276792d88d.jpg";